import axios from 'axios';
import {
  getAccessToken,
  liffGetProfile,
} from '../promotion/auth.service';
import { getCustomerFOA } from '../promotion/foa.service';
import CustomSweetAlert from '../../common/customSweetAlert/CustomSweetAlert';

const liff = window.liff;
const AxiosHealthWellness = axios.create({
  timeout: process.env.NETWORK_TIMEOUT,
});

AxiosHealthWellness.interceptors.request.use(async (config) => {
  const token = await getAccessToken();
  config.headers.authorization = `Bearer ${token}`;
  const liffProfile = await liffGetProfile();
  const customer = await getCustomerFOA(liffProfile.userId);
  config.headers.account = `${customer?.amwayNumber}`;
  config.headers.customer = `${customer?.partyId}`;
  return config;
});

AxiosHealthWellness.interceptors.response.use(
  (res) => {
    return res;
  },
  (error) => {
    if (error.code === 'ECONNABORTED') {
      CustomSweetAlert({
        title: "",
        text: "Request timed out",
        confirmButtonText: "ตกลง",
      });
      console.error('Request timed out');
    }
    if (
      (error?.response !== undefined && error?.response?.status === 401) ||
      error.response?.status === 403
    ) {
      sessionStorage.removeItem('facadeToken');
      window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default AxiosHealthWellness;
